export default {
  label: {
    color: "#366b92",
    fontWeight: 600,
    fontSize: "14px",
    // textTransform: "uppercase",
    lineHeight: "20px"
  }
};
